import youtubePlayer from './home-ui/youtube-player';
window.ui = { player: youtubePlayer };

import '../styles/sudda/main.scss';
import './main.js';
import profileLevel from './home-ui/sudda-profile-level';

profileLevel();
